<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'admin-billing-invoice-list' })"
          >Back to Invoice</vs-button>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3 mr-6"
            :disabled="!validateForm"
          >Generate Invoice</vs-button>
          <vs-button
            class="mt-3"
            @click="Add"
          >Add Invoice</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="smsc-box">
        <div class="smsc-box__col">
          <div class="smsc-box__item">
            <label class="vs-input--label " :for="start_date_validate_name">Start Date</label>
            <div>
              <flat-pickr
                class="w-100"
                placeholder="Select Date"
                v-validate="'required'"
                :name="start_date_validate_name"
                :config="{
                  ...configdateTimePicker,
                  dateFormat: 'Y-m-d',
                  defaultDate: null,
                  enableTime: false,
                  enableSeconds: false
                }"
                v-model="payload.invoice_start_date"
              />

            </div>
            <span class="text-danger help text "v-if="errors.has(start_date_validate_name)">{{ errors.first(start_date_validate_name) }}</span>

          </div>

          <div class="smsc-box__item">
            <label class="vs-input--label" for="Company">Company</label>
            <v-select
              multiple
              name="Company"
              v-validate="'required'"
              class="filter-select"
              v-model="companie_uuid"
              :options="companies"
              @input="getValue"
              label="name"
              placeholder="Select Company"
            />
            <span class="text-danger help text " v-if="errors.has('Company')">{{ errors.first('Company') }}</span>
          </div>

        </div>
        <div class="smsc-box__item">
          <label class="vs-input--label" :for="end_date_validate_name">End Date</label>
          <div>
            <flat-pickr
              class="w-100"
              placeholder="Select Date"
              :name="end_date_validate_name"
              v-validate="'required'"
              :config="{
                  ...configdateTimePicker,
                  dateFormat: 'Y-m-d',
                  defaultDate: null,
                  enableTime: false,
                  enableSeconds: false
                }"
              v-model="payload.invoice_end_date"
            />
          </div>

          <span class="text-danger help text "v-if="errors.has(end_date_validate_name)">{{ errors.first(end_date_validate_name) }}</span>
<!--          <span class="text-danger help text " v-if="errors.has(end_date_validate_name)">{{ errors.first(company_name) }}</span>-->
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Mixins
import DateTimeMixin from '@/mixins/datetime.js'

// Packages
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  mixins: [DateTimeMixin],
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      start_date_validate_name:"Start Date",
      end_date_validate_name:'End Date',
      company_name:'Company',
      companie_uuid: [],
      value:'',
      companies: [],

      // Request data
      payload: {
        invoice_start_date: null,
        invoice_end_date: null,
        company_uuid: null
      }
    }
  },
  computed: {
    validateForm() {
      const values = Object.values(this.payload)
      const is_valid = values.findIndex(value => !value) !== -1

      return !is_valid
    }
  },
  created() {
    this.FetchData()
  },
  methods: {
    getValue(e) {
      console.log(e)
      this.payload.company_uuid = e
    },
    async Add() {
      const valid = await this.$validator.validate()

      if (!valid) {
        return
      }
      this.$vs.loading()
      this.$store.dispatch('invoice/Add', this.payload)
      .then(res => {
        if (res.success) {
          this.$router.push({ name: 'admin-billing-invoice-list' })
          this.$vs.notify({
            title: 'Adding invoice Attempt',
            text: 'Invoice has been added',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
        }
      })
      .catch(err => {
        this.$vs.notify({
          title: 'Error',
          text: 'Error',
          iconPack: 'feather',
          icon: 'iicon-alert-circle',
          color: 'danger'
        })
      })
      .finally(() => this.$vs.loading.close())
    },
    async FetchData() {
      this.$vs.loading()
      const { total: TotalForCompany } = await this.$store.dispatch('company/GetList', { per_page: 0 })
      const p1 = await this.$store.dispatch('company/GetList', { per_page: TotalForCompany, order_by: 'company_name', order_dir: 'asc' })

      Promise.all([p1])
      .then(res => this.companies = res[0].items.map(this.TransformCompany))
      .catch(err => console.log(err))
      .finally(() => this.$vs.loading.close())
    },

    // Transform functions
    TransformCompany(item) {
      return {
        name: item.company_name,
        value: item.company_uuid
      }
    }
  }
}
</script>

<style scoped lang="scss">
.company-item-list {
  width: 204% !important;
}
</style>
